import { render, staticRenderFns } from "./KBList.vue?vue&type=template&id=9e07724e&scoped=true&lang=pug"
import script from "./KBList.vue?vue&type=script&lang=js"
export * from "./KBList.vue?vue&type=script&lang=js"
import style0 from "./KBList.vue?vue&type=style&index=0&id=9e07724e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e07724e",
  null
  
)

export default component.exports